<template>
    <div class="apn-page apn-faqs">
        <section class="section--header">
            <h1>Frequently Asked Questions</h1>
        </section>

        <section class="section--tab-view">
            <div class="button-group">
                <button class="nav-btn"
                    :class="{'active-tab': faq_tab === 'general'}" 
                    @click="setFaq('general')">
                    General</button>
                <!-- <button class="nav-btn"
                    :class="{'active-tab': faq_tab === 'connection'}" 
                    @click="setFaq('connection')">
                    Connection</button>
                <button class="nav-btn"
                    :class="{'active-tab': faq_tab === 'plans'}" 
                    @click="setFaq('plans')">
                    Plans</button> -->
                <button class="nav-btn"
                    :class="{'active-tab': faq_tab === 'billing'}" 
                    @click="setFaq('billing')">
                    Billing</button>
                <!-- <button class="nav-btn"
                    :class="{'active-tab': faq_tab === 'others'}" 
                    @click="setFaq('others')">
                    Others</button> -->
            </div>
        </section>

        <section class="section section--loading" v-show="loading">
            <div class="lds-css ng-scope">
                <div style="width:100%;height:100%" class="lds-ellipsis">
                    <div><div></div></div>
                    <div><div></div></div>
                    <div><div></div></div>
                    <div><div></div></div>
                    <div><div></div></div>
                </div>
            </div>
        </section>

        <!-- <section class="section section--faqs" v-if="plans"> -->
        <section class="section section--faqs">
            <article class="qas" v-show="faq_tab === 'general'">
                <question-answer v-for="qa in qas" :key="qa.id" :qa="qa" @toggleMessage="toggleMessage($event, 'general')"/>
            </article>

            <article class="qas" v-show="faq_tab === 'connection'">
                <h1>Connection Issues</h1>
            </article>

            <article class="qas" v-show="faq_tab === 'plans'">
                <h1>Plan Info</h1>
            </article>

            <article class="qas" v-show="faq_tab === 'billing'">
                <question-answer v-for="qa in qab" :key="qa.id" :qa="qa" @toggleMessage="toggleMessage($event, 'billing')"/>
            </article>

            <article class="qas" v-show="faq_tab === 'others'">
                <h1>Other Questions</h1>
            </article>
        </section>

        <apn-footer/>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex"
import QuestionAnswer from '@/components/QuestionAnswer'
import ApnFooter from '@/components/ApnFooter'

export default {
    name: 'Faqs',
    components: {
        QuestionAnswer,
        ApnFooter,
    },
    data() {
        return {
            qas: [
                {
                    id: 1,
                    question: '1. MyanmarAPN ကိုဘယ်လိုဆက်သွယ်လို့ရမလဲ။',
                    answer: `
                        Call Center Phone : <a href="tel:09772668899" style="text-decoration:none; color:#00AEEF">09 772 66 88 99</a> <br>
                        Billing Phone : <a href="tel:09891748803" style="text-decoration:none; color:#00AEEF">09 891748803</a> <br>
                        Facebook Page Messenger : <a href="https://www.messenger.com/t/mmapnisp/" target="_blank" style="text-decoration:none; color:#00AEEF">Chat</a>
                    `,
                    isExpanded: false
                },
                {
                    id: 2,
                    question: '2. MyanmarAPN ရဲ့ ဝန်ဆောင်မှုတွေကို ဘယ်လို ရယူနိုင်လဲ။',
                    answer: `
                        Call Center ဖုန်းနံပါတ် 09 772 66 88 99  မှ တဆင့်  မနက် ၈ နာရီမှ ည ၈နာရီအတွင်း ဖုန်းခေါ်ဆိုမေးမြန်းနိုင်ပါသည်။ <a href="https://www.messenger.com/t/mmapnisp/" target="_blank" style="text-decoration:none; color:#00AEEF">Facebook Messenger Page</a>  သို့မဟုတ် Viber နံပါတ် 09-891748856 မှ တဆင့်လည်း message ပေးပို့မေးမြန်းနိုင်ပြီး အမြန်ဆုံးအကြောင်းပြန်ပေးသွားပါ့မယ်။
                    `,
                    isExpanded: false
                },
                {
                    id: 3,
                    question: '3. Customer ID နံပါတ်ကို သိချင်ရင် ဘယ်လို ရယူနိုင်မလဲ။',
                    answer: `
                        မိမိအိမ်တွင် Installation တပ်ဆင်ပြီးပါက Sender ID အမည် Myanamar APN ဖြင့် SMS မှ တဆင့် Customer ID ကို ပေးပို့ပေးပါတယ်။
                    `,
                    isExpanded: false
                },
                {
                    id: 4,
                    question: '4. စက်ပစ္စည်းတပ်ဆင်မှုများအတွက် ထပ်မံပေးဆောင်ရန် လိုအပ်ပါသလား။',
                    answer: `
                        ထပ်မံပေးဆောင်ရန် မလိုအပ်ပါ။
                    `,
                    isExpanded: false
                },
                {
                    id: 5,
                    question: '5. အင်တာနက်ချိတ်ဆက်သုံးစွဲရာတွင် အဆင်မပြေမှု တစ်စုံတစ်ရာ ရှိခဲ့ပါက ဘယ်လို ဆက်သွယ်ရမလဲ။',
                    answer: `
                        Call Center ဖုန်းနံပါတ် 09 772 66 88 99  မှ တဆင့်  မနက် ၈ နာရီမှ ည ၈နာရီအတွင်း ဖုန်းခေါ်ဆိုမေးမြန်းနိုင်ပါသည်။ <a href="https://www.messenger.com/t/mmapnisp/" target="_blank" style="text-decoration:none; color:#00AEEF">Facebook Messenger Page</a> သို့မဟုတ် Viber နံပါတ် 09-891748856 မှ တဆင့်လည်း message ပေးပို့မေးမြန်းနိုင်ပြီး အမြန်ဆုံးအကြောင်းပြန်ပေးသွားပါ့မယ်။
                    `,
                    isExpanded: false
                },
                {
                    id: 6,
                    question: '6. အင်တာနက်ချိတ်ဆက်သုံးစွဲရာတွင် အခက်အခဲတစ်စုံတစ်ရာအား လာရောက်ဖြေရှင်းချိန်တွင် ဝန်ဆောင်ခများ ထပ်မံပေးဆောင်ရန် လိုအပ်ပါသလား။',
                    answer: `
                        ၀န်ဆောင်ခပေးရန် မလိုအပ်ပါ။
                    `,
                    isExpanded: false
                },
                {
                    id: 7,
                    question: '7. ၀န်ဆောင်မှုကို ရွှေ့ပြောင်းတပ်ဆင်ခြင်း၊ ယာယီရပ်ဆိုင်းခြင်းနှင့် ဝန်ဆောင်မှုရပ်ဆိုင်းခြင်းတို့အတွက် ဘယ်လိုလုပ်ရမလဲ။',
                    answer: `
                        စာချုပ်သက်တမ်း အနည်းဆုံး (၃)လပြည့်ပြီးသော သုံးစွဲသူcustomer များသာ အထက်ပါ ဝန်ဆောင်မှုများကို ပြုလုပ်နိုင်ပါသည်။ ပြုလုပ်မည်ဆိုပါက မိမိရပ်ဆိုင်းလိုသော သို့မဟုတ် ရွှေ့ပြောင်းတပ်ဆင်လိုသော ရက်မတိုင်မှီ (၂)ပတ် ကြိုတင်၍ Call Center 09 772 66 88 99, <a href="https://www.messenger.com/t/mmapnisp/" target="_blank" style="text-decoration:none; color:#00AEEF">Facebook Messenger Page</a>, သို့မဟုတ် Viber နံပါတ် 09-891748856 များသို့ ဆက်သွယ်အကြောင်းကြားရမည်။ အကြောင်းကြားမှုမရှိခဲ့ပါက အင်တာနက်လိုင်းလစဉ်ကြေးမှာ ပုံမှန်အတိုင်း ဆက်လက်ကောက်ခံသွားမည်ဖြစ်သောကြောင့် နစ်နာမှုများရှိမည်ဖြစ်သည်။
                    `,
                    isExpanded: false
                },
            ],
            qab: [
                {
                    id: 1,
                    question: '1. ၀န်ဆောင်မှုစတင်ရယူမည့် ကနဦးလ၏ လစဉ်ကြေးကို ဘယ်လိုပေးဆောင်ရမလဲ။',
                    answer: `
                        ၀န်ဆောင်မှုကို သုံးစွဲပြီး ၂ရက်အတွင်း လစဉ်ကြေး Invoice (သို့) Bill ကို SMS မှပေးပို့ပါမည်။ သို့ဖြစ်၍ ဝန်ဆောင်မှုရယူချိန်တွင် စာရင်းသွင်းထားသော ဖုန်းနံပါတ်အား မှန်ကန်စွာ ဖြည့်သွင်းပေးရန် လိုအပ်ပါသည်။ SMS လက်ခံရရှိပြီး (၃)ရက်အတွင်း နောက်ဆုံးထား၍ ပေးဆောင်ရပါမည်။
                    `,
                    isExpanded: false
                },
                {
                    id: 2,
                    question: '2. ဘယ်အချိန်ှမှာ အင်တာနက်သုံးစွဲသူများထံသို့ လစဉ်ကြေး Invoice (သို့) Bill များ ပေးပို့သလဲ။',
                    answer: `
                    လစဉ် လတစ်လ၏ အစ(၁၀)ရက်အတွင်း Invoice (သို့) Bill များကို SMS မှ ပေးပို့ပါမည်။  SMS မှာ Sender ID “Myanmar APN” အမည်ဖြင့်ပေးပို့ပါသည်။ SMS အတွင်း ဖော်ပြထားသည့် အင်တာနက်လစဉ်ကြေး နောက်ဆုံး ပေးသွင်းရမည့် ရက်စွဲထက် နောက်မကျဘဲ ပေးဆောင်ရမည်ဖြစ်သည်။ ပေးဆောင်မှုနောက်ကျခဲ့ပါက System မှ အလိုအလျောက် လိုင်းဖြတ်တောက်မှုများ ရှိနိုင်ပါသည်။ <br>
                    ကျသင့်ငွေပေးဆောင်ရမည့်အချက်အလက်များ - <br>
                    <ul>
                        <li>သတ်မှတ်ထားသော ဖော်ပြပါ နောက်ဆုံးပေးဆောင်ရမည့် ရက်စွဲမတိုင်ခင် ပေးဆောင်ရမည်။</li>
                        <li>ငွေပေးဆောင်ရာတွင် Invoice (သို့) Bill နံပါတ်အားအသုံးပြုရမည်။</li>
                        <li>သုံးစွဲသူ ပေးဆောင်ရမည့် ငွေပမာဏ</li>
                    </ul>
                    လူကြီးမင်းလက်ခံရရှိမည့် ငွေတောင်းခံလွှာ ပုံစံ (SMS) <br>
                    <img width="50%" src="https://myanmarapn.com/img/bill-sms.jpg" alt="Message Sample">
                    `,
                    isExpanded: false
                },
                {
                    id: 3,
                    question: '3. အင်တာနက်လစဉ်ကြေးကို ဘယ်လိုပေးဆောင်နိုင်မလဲ။',
                    answer: `
                        SMS မှတဆင့် ပေးပို့ထားသော အင်တာနက်လစဉ်ကြေး(Bill) များကို AYA, KBZ, CB, Wave Money, K Pay, One Pay, Yoma Bank များကို အသုံးပြု၍ အွန်လိုင်းPayment များကို လွယ်ကူချောမွေ့စွာ ပေးဆောင်နိုင်သည်။
                    `,
                    isExpanded: false
                },
                {
                    id: 4,
                    question: '4. ငွေပေးချေခြင်း အဆင်ပြေအောင်မြင်ကြောင်း ဘယ်လိုသိနိုင်မလဲ။',
                    answer: `
                        ဘဏ်မှ လက်ခံရရှိကြောင်း ပြေစာ၊ E-slip ကို လက်ခံရရှိပါမည်။ လက်ခံရရှိပြီးနောက် 09-891748803 Viber နံပါတ်သို့ Screen Shot ရိုက်ပို့ပေးရပါမယ်။ သက်ဆိုင်ရာ ဌာနမှ ငွေပေးချေမှု လက်ခံရရှိကြောင်း Viber မှ စာပြန်ပို့ခြင်းဖြင့် မိမိ၏ ငွေပေးချေမှု အဆင်ပြေအောင်မြင်ကြောင်း သိရှိနိုင်ပါတယ်။
                    `,
                    isExpanded: false
                },
                {
                    id: 5,
                    question: '5. ဘဏ်မှငွေပေးချေခြင်း အဆင်မပြေဖြစ်ပွားခဲ့ပါက ဘယ်လိုလုပ်မလဲ။',
                    answer: `
                        09-891748803 သို့ ဖုန်းခေါ်ဆိုခြင်း သို့မဟုတ် Viber မှ တဆင့် ဆက်သွယ်မေးမြန်းနိုင်ပါတယ်။
                    `,
                    isExpanded: false
                },
                {
                    id: 6,
                    question: '6. ကြိုတင်ငွေပေးဆောင်သော အစီအစဉ်များကို ရယူခဲ့ပါက ပထမသတ်မှတ်ထားသောသက်တမ်းကုန်ဆုံးပါက ဝန်ဆောင်မှုဆက်လက်ရယူရန် လစဉ်ကြေးကို ဘယ်လို ပေးဆောင်ရမလဲ။',
                    answer: `
                        မိမိမူလရယူထားသော အစီအစဉ်အတိုင်း ကြိုတင်ပေးဆောင်ခြင်း (သို့) လစဉ်ကြေးကိုတစ်လချင်းစီပေးဆောင်ခြင်းဖြင့် မိမိစိတ်ကြိုက် ပြန်လည်အသုံးပြုနိုင်ပါသည်။
                    `,
                    isExpanded: false
                },
                {
                    id: 7,
                    question: '7. AYA ဖြင့်ငွေပေးဆောင်ခြင်း။',
                    answer: `
                        <video width="100%" controls>
                            <source src="https://admin.myanmarapn.com/videos/aya.mp4" type="video/mp4">
                        </video>
                    `,
                    isExpanded: false
                },
                {
                    id: 8,
                    question: '8. CB ဖြင့်ငွေပေးဆောင်ခြင်း။',
                    answer: `
                        <video width="100%" controls>
                            <source src="https://admin.myanmarapn.com/videos/cb.mp4" type="video/mp4">
                        </video>
                    `,
                    isExpanded: false
                },
                {
                    id: 9,
                    question: '9. KBZ ဖြင့်ငွေပေးဆောင်ခြင်း။',
                    answer: `
                        <video width="100%" controls>
                            <source src="https://admin.myanmarapn.com/videos/kbz.mp4" type="video/mp4">
                        </video>
                    `,
                    isExpanded: false
                },
                {
                    id: 10,
                    question: '10. Wave ဖြင့်ငွေပေးဆောင်ခြင်း။',
                    answer: `
                        <video width="100%" controls>
                            <source src="https://admin.myanmarapn.com/videos/wave.mp4" type="video/mp4">
                        </video>
                    `,
                    isExpanded: false
                },
            ],
        }
    },
    methods: {
        ...mapActions({
            setFaq: 'setFaq',
            // getPlans: 'getPlans',
        }),
        toggleMessage(id, tab) {
            if(tab == 'billing') {
                this.qab[id - 1].isExpanded = !this.qab[id - 1].isExpanded
            } else {
                this.qas[id - 1].isExpanded = !this.qas[id - 1].isExpanded
            }
        }
    },
    computed: {
        ...mapState({
            faq_tab: state => state.faq_tab,
            // plans: state => state.plans,
            loading: state => state.loading,
        }),
    },
    // mounted() {
    //     if(!this.plans) this.getPlans()
    // }
}
</script>

<style scoped lang="scss">
.apn-faqs {
    .section {
        padding: 40px 0;
    }

    .section--header {
        // margin-top: var(--header-height);

        h1 {
            text-transform: uppercase;
            font-size: 42px;
            font-weight: 300;
            text-align: center;
            padding: 50px 0 25px;
            color: var(--primary);

            @media (min-width: 992px) {
                font-size: 54px;
            }
        }
    }

    .section--tab-view {
        width: 100%;
        min-height: 120px;
        padding: 0 1rem;
        display: flex;
        justify-content: center;
        align-items: center;

        @media (min-width: 992px) {
            min-height: 100px;
            padding: 0 5rem;
        }

        .button-group {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            overflow: hidden;

            .nav-btn {
                --border: 1px solid var(--primary);
                flex: 1;
                width: 100%;
                margin: 0;
                padding: 8px 10px;
                color: var(--primary);
                font-size: 14px;
                line-height: 13px;
                font-weight: 600;
                border-bottom: var(--border);
                transition: background-color .2s ease;

                @media (min-width: 992px) {
                    max-width: 350px;
                    height: 40px;
                    font-size: 16px;
                    line-height: 15px;
                    padding: 0 20px;
                }
            }

            .nav-btn.active-tab {
                color: #fff;
                background-color: var(--primary);
                cursor: not-allowed;
            }

            .nav-btn:not(.active-tab):hover {
                background-color: var(--theme-bg);
            }

            @media (min-width: 768px) {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                overflow: hidden;
            }
        }
    }

    .section--faqs {
        width: 100%;
        max-width: var(--max-width);
        margin: 0 auto;
        padding: 0 1rem;

        @media (min-width: 992px) {
            padding: 0 5rem;
        }

        .qas {

        }

    }
}

.section--loading {
    width: 100%;
    height: 320px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
